// src/App.js
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Registertea from './Components/Registertea';
import Home from './Components/Home';
import BillPage from './Components/bill';
import Dashome from './Components/Panel/Dashome';
import './App.css';
import EmployeeLogin from './Components/login';
import FactoryForm from './Components/factoryform';
import EmployeePage from './Components/employeepage';
import FactoryBill from './Components/factorybill';
import Unauthorized from './Unauthorized';
import PrivateRoute from './PrivateRoute';
import TermsAndConditions from './termsandcondition';
import PrivacyPolicy from './privacypolicy';
import DonationPage from './donate';
import About from './about';
import BillFormatPage from './Components/billpdfformat';
import BillPagepdf from './Components/billpdfformat';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Home />} />
        <Route path="/login" element={<EmployeeLogin />} /> */}

        <Route path="/" element={<EmployeeLogin />} />
        {/* Admin Protected Routes */}
        <Route path="/dashboard/*" element={
          <PrivateRoute allowedRoles={['admin']}>
            <Dashome />
          </PrivateRoute>
        } />
      

        {/* Employee Protected Routes */}
        <Route path="/Registertea" element={
          <PrivateRoute allowedRoles={['employee','admin']}>
            <Registertea />
          </PrivateRoute>
        } />
        <Route path="/Bill" element={
          <PrivateRoute allowedRoles={['employee',]}>
            <BillPage />
          </PrivateRoute>
        } />

 <Route path="/billformat" element={
          <PrivateRoute allowedRoles={['employee',]}>
          <BillPagepdf/>  
          </PrivateRoute>
        } />

        <Route path="/factoryreg" element={
          <PrivateRoute allowedRoles={['employee']}>
            <FactoryForm />
          </PrivateRoute>
        } />
        <Route path="/emppage" element={
          <PrivateRoute allowedRoles={['employee']}>
            <EmployeePage />
          </PrivateRoute>
        } />
        <Route path="/factorybill" element={
          <PrivateRoute allowedRoles={['employee']}>
            <FactoryBill />
          </PrivateRoute>
        } />

        {/* Unauthorized Page */}
        <Route path="/unauthorized" element={<Unauthorized />} />
        {/* <Route path='/terms-and-conditions' element={<TermsAndConditions/>}/>
         <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
          <Route path='/donate' element={<DonationPage/> }/>
           <Route path='/about' element={<About/>}/> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
